import axios from '@/components/api/axios';

async function getBankList() {
  const res = await axios.axiosGet('/api/banks/getAll', null);
  return res;
}

async function getBranchList(bankId) {
  let data = {
    bankId: bankId
  }
  const res = await axios.axiosGet('/api/banks/getBranchList', data);
  return res;
}

export default {
  getBankList,
  getBranchList
}



// WEBPACK FOOTER //
// ./src/components/api/bank.js